import { Component } from 'preact';
import Table from './table'
import SelectedItemEC from './selectedItemEC'
import axios from 'axios';
import MobileNav from './mobileNav'
import Loader from '../../util/loader'
//import ItemContent from './itemContent/itemContent'

export default class ProductComparison extends Component {


  passedSetState = (state, value) =>{
    this.setState({[state]: value})
  }

  compareItemSelected( selectedItemId, selectedItemBasicContent ){
    this.setState({selectedItemId, selectedItemBasicContent})
  }

  constructor(props) {
    super(props);

    // set initial selected item
    this.state = { selectedItemId: this.props.initialPageItemId, compareItemsContent: 'loading' };

  }

  componentWillMount(){
    //get data for all items in compareTable
    let itemsContentPromiseArray = []
    let compareItemsContent = {}
    let compareProducts = []

    //console.log(this.props.tableData.compareProducts)

    //first get compareProducts for this item


    return axios.get('https://columbus-c4de8.firebaseio.com/products/' + this.state.selectedItemId + '/content/compareTable/items.json').then( (snap)=> {
    compareProducts = snap.data ? snap.data : null

    if (!compareProducts){
      throw new Error('No compare table items')
    }

    compareProducts.forEach( currentItem=> {
      itemsContentPromiseArray.push( axios.get('https://columbus-c4de8.firebaseio.com/products/' + currentItem.itemId + '/content.json') )
    })

    return Promise.all(itemsContentPromiseArray)

    }).then( results => {

        results.map( current=> {
          let itemContent = current.data
          if (!itemContent){ return null}
          compareItemsContent[itemContent.basicContent.itemId] = itemContent
        })

      this.setState({compareItemsContent, compareProducts, errorMessage: null})

    }).catch( err => {
      console.error(err.message)
      this.setState({errorMessage: err.message, compareItemsContent: null})
    })


  }

  render(){

    if (this.state.compareItemsContent === 'loading'){
      return (
        <div  className='col-xs-12'>
					<Loader />
				</div>
  		);
    } else if (this.state.errorMessage){
			return null
		}

    let selectedItemTitle = this.state.compareItemsContent[this.state.selectedItemId] && this.state.compareItemsContent[this.state.selectedItemId].basicContent.shortName
    let affiliateGoToPageHref="https://linksynergy.walmart.com/deeplink?id=mZBF1JmBhNo&mid=2149&u1=GTP&murl=http%3A%2F%2Fwww.walmart.com%2Fip%2F" + this.state.selectedItemId
    //let regularHref = 'https://www.walmart.com/ip/' + this.state.selectedItemId

		return (
			<div className='row col-xs-12'>

				<div className='col-xs-12'>
					<div className='s1-header'>
						{this.props.tableData.title}
					</div>
				</div>



        <div className='col-xs-12 mobileSelectItemNav'>
          <MobileNav passedSetState={this.passedSetState} {...this.state} />
        </div>

        <div className='col-xs-12'>
				    <Table {...this.state} tableData={this.props.tableData} passedSetState={this.passedSetState} compareItemsContent={this.state.compareItemsContent} />
        </div>

        <div className='col-xs-12' >
					<div className='s1-header-withItemLink'>
            {selectedItemTitle}
          </div>
          <div style={{padding:'5px 2px'}}>
            <a  data-contenttype="ct" data-btnlocation="header" data-itemid={this.state.selectedItemId} alt='Go To Page' href={affiliateGoToPageHref} target='_blank'
	             rel='noreferrer noopener' style={{ textDecoration: 'underline'}}
            > Go To Page›</a>
				  </div>
        </div>

        <div className='row col-xs-12'>
				    <SelectedItemEC selectedItemId={this.state.selectedItemId} key={this.state.selectedItemId} />
        </div>


			</div>
		);
  }

}



// WEBPACK FOOTER //
// ./components/contentTypes/compareTable/compareTable.js